import packageData from '../package.json'

export const config = {
    mantainance: false,
    dev: false,
    bundle: "tcs.rhubbit.com",
    version: packageData.version,
    acceptApiVersion: '2.0.0', 
    refreshTokenAdvance: 300, //seconds before expire
    apiKey: "c17cd389-d857-11ed-a15f-96000211878b",
    baseurl: "https://tcs-api.rhubbit.com",
    defaultLanguage: { code: "it", label: "Italian" },
    languages: [
        { code: "gb", label: "English" },
        { code: "it", label: "Italian" },
    ],
    tab_channel: {
        device: "tcs.rhubbit.com/device",
        mainTab: "tcs.rhubbit.com/main-tab"
    },
    push_notification: {
        enabled: false,
        apiKey: "xxx",
        config: {  // WARNING: Remember to copy this params in /public/firebase-messaging-sw.js
            apiKey: "...",
            authDomain: "...",
            projectId: "...",
            storageBucket: "...",
            messagingSenderId: "...",
            appId: "...",
            measurementId: "..."
        }
    },
    restError: {
        BadRequest: "1000",
        PreconditionFailed: "6000",
        Forbidden: "8000",
    }
};